import React from "react";

/**
 * Prev / Next pagination controls for job listings. Renders nothing when the
 * total fits on a single page so tools with light usage stay clean.
 *
 * Use with the `useJobsPagination` hook:
 *   const { page, totalPages, totalFinished, setPage } = useJobsPagination({...});
 *   <JobsPagination page={page} totalPages={totalPages} totalFinished={totalFinished} onPageChange={setPage} />
 */
export default function JobsPagination({
  page,
  totalPages,
  totalFinished,
  onPageChange,
}) {
  if (!totalPages || totalPages <= 1) return null;

  const canPrev = page > 1;
  const canNext = page < totalPages;

  return (
    <div className="tool-jobs-pagination">
      <span className="tool-jobs-pagination-label">
        Page {page} of {totalPages} ({totalFinished} job{totalFinished === 1 ? "" : "s"})
      </span>
      <div className="tool-jobs-pagination-buttons">
        <button
          type="button"
          className="tool-btn-secondary"
          disabled={!canPrev}
          onClick={() => canPrev && onPageChange(page - 1)}
        >
          Prev
        </button>
        <button
          type="button"
          className="tool-btn-secondary"
          disabled={!canNext}
          onClick={() => canNext && onPageChange(page + 1)}
        >
          Next
        </button>
      </div>
    </div>
  );
}
